export enum DiseaseResourceTranslKey {
    DISEASE_RESOURCE_TITLE = "disease:resource:title",
    DISEASE_RESOURCE_URL = "disease:resource:url",
    DISEASE_RESOURCE_LOCATION = "disease:resource:location",
    DISEASE_RESOURCE_TYPE = "disease:resource:type",
    DISEASE_RESOURCE_HEADING = "disease:resource:heading",
    EXTERNAL_BADGE = "disease:resource:externalBadge",
    INTERNAL_BADGE = "disease:resource:internalBadge"
}
